import { BLAdmin } from '@/types/profile.types';
import { Get } from '../helpers';
import { EmailDomainFlag } from '@/types/email-domain-flags.types';
import { EPermissions } from '@/types/permissions.types';

export function GetAdmins({
  channel,
  includeLockedEmails = false,
  roles,
}: {
  channel: number;
  includeLockedEmails?: boolean;
  roles?: EPermissions[];
}): Promise<
  | BLAdmin[]
  | (BLAdmin & { flags: EmailDomainFlag[] })[]
  | { admins: BLAdmin[]; temporarilyLockedEmails: { [key: string]: string } }
> {
  const params = new URLSearchParams({
    onlyChannel: channel.toString(),
  });
  if (includeLockedEmails) {
    params.append('option', 'includeLockedEmails');
  }
  if (roles?.length) {
    roles.forEach((role) => {
      params.append('roles', role);
    });
  }
  return Get({
    url: `/v3/admin/auth/admins?${params.toString()}`,
  });
}
